import { render } from "./DefaultAvatar.vue?vue&type=template&id=e534fe08"
const script = {}

import "./DefaultAvatar.vue?vue&type=style&index=0&id=e534fe08&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__